export default "__VITE_ASSET__D118cuLq__"